const PORTAL_MAGIC_INTENT_KEY = 'rebound.portalMagicLinkIntent'

export function safePortalPath(value = '/portal') {
  const path = String(value || '/portal')
  if (!path.startsWith('/portal')) return '/portal'
  if (path.startsWith('//')) return '/portal'
  if (path.includes('\\') || /^[a-z][a-z0-9+.-]*:/i.test(path)) return '/portal'
  return path
}

export function rememberPortalMagicIntent(path = '/portal') {
  try {
    window.localStorage.setItem(PORTAL_MAGIC_INTENT_KEY, safePortalPath(path))
  } catch {}
}

export function readPortalMagicIntent() {
  try {
    return safePortalPath(window.localStorage.getItem(PORTAL_MAGIC_INTENT_KEY) || '/portal')
  } catch {
    return '/portal'
  }
}

export function hasPortalMagicIntent() {
  try {
    return Boolean(window.localStorage.getItem(PORTAL_MAGIC_INTENT_KEY))
  } catch {
    return false
  }
}

export function clearPortalMagicIntent() {
  try {
    window.localStorage.removeItem(PORTAL_MAGIC_INTENT_KEY)
  } catch {}
}
